// extracted by mini-css-extract-plugin
export var passwordForm = "wKGxusoxSsiCXE16O78K";
export var passwordFormButton = "d1__doekLxkkM6jcLixZ";
export var passwordFormDescription = "arbCKkxH3dy5VxsrpY6W";
export var passwordFormHeading = "G0SfqWCBjH42D5h2YKew";
export var passwordFormTermsOfService = "Gzunnv87HrEl3bCYUnI0";